var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergySeparator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 139,
    viewBox: "0 0 186 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.075 9.29924C173.257 6.85051 173.851 3.31804 176.409 1.4185C178.967 -0.481161 182.518 -0.0288906 184.337 2.41972C186.155 4.8665 185.558 8.39359 183.001 10.2933C180.444 12.1929 176.892 11.7459 175.075 9.29924Z",
    fill: "#CA9DAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.425 22.4101C155.606 19.9613 156.201 16.429 158.758 14.5293C161.316 12.6297 164.868 13.0819 166.687 15.5307C168.504 17.9775 167.908 21.5042 165.351 23.4038C162.793 25.3038 159.242 24.8568 157.425 22.4101Z",
    fill: "#CA9DAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.774 35.5203C137.955 33.0719 138.55 29.5393 141.108 27.6396C143.666 25.7399 147.217 26.1925 149.036 28.6409C150.853 31.0877 150.257 34.6147 147.7 36.5144C145.142 38.414 141.591 37.9671 139.774 35.5203Z",
    fill: "#CA9DAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.124 48.6308C120.305 46.182 120.9 42.6497 123.457 40.75C126.015 38.8504 129.567 39.3026 131.385 41.7514C133.203 44.1982 132.607 47.7253 130.049 49.6248C127.492 51.5244 123.941 51.0775 122.124 48.6308Z",
    fill: "#CA9DAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.473 61.7417C102.654 59.293 103.249 55.7606 105.807 53.861C108.364 51.9611 111.915 52.4136 113.734 54.8623C115.552 57.3088 114.956 60.8359 112.398 62.7355C109.841 64.6352 106.29 64.1883 104.473 61.7417Z",
    fill: "#CA9DAC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8217 74.8514C85.0033 72.4027 85.598 68.8703 88.1556 66.9707C90.7133 65.0711 94.265 65.5233 96.0839 67.972C97.9012 70.4188 97.3051 73.9459 94.7474 75.8456C92.1903 77.7451 88.6395 77.2982 86.8217 74.8514Z",
    fill: "#CA9DAC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1715 87.9623C67.3527 85.5136 67.9479 81.9811 70.505 80.0816C73.0626 78.1819 76.6144 78.6342 78.4332 81.0829C80.2506 83.5296 79.6544 87.0564 77.0973 88.9563C74.5397 90.856 70.9889 90.4091 69.1715 87.9623Z",
    fill: "#CA9DAC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.521 101.073C49.7016 98.6241 50.2969 95.0914 52.8545 93.1919C55.4116 91.2922 58.9639 91.7447 60.7822 94.1932C62.5996 96.6399 62.0039 100.167 59.4463 102.067C56.8887 103.966 53.3379 103.519 51.521 101.073Z",
    fill: "#CA9DAC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8699 114.184C32.051 111.735 32.6458 108.202 35.2034 106.303C37.761 104.403 41.3128 104.855 43.1316 107.304C44.949 109.751 44.3533 113.278 41.7957 115.178C39.238 117.077 35.6873 116.63 33.8699 114.184Z",
    fill: "#CA9DAC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0034 117.74C28.4092 115.594 25.0073 116.211 25.0073 116.211C10.3491 102.788 0.258789 137.832 0.258789 137.832C0.258789 137.832 37 141.324 29.4839 122.795C29.4839 122.795 31.1724 119.826 30.0034 117.74Z",
    fill: "#C38F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergySeparator);
export default __webpack_public_path__ + "static/media/energy-separator.b55ca92ff9f141418a83e929c4f83b1b.svg";
export { ForwardRef as ReactComponent };